import { useIntl } from "../lib/i18n";

export default function LanguageSwitcher() {
  const { locale, setLocale, t } = useIntl();
  return (
    <select
      value={locale}
      onChange={(e) => setLocale(e.target.value as "en" | "es")}
      className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm"
    >
      <option value="en">{t("lang.en")}</option>
      <option value="es">{t("lang.es")}</option>
    </select>
  );
}
